export default {"src":"/_next/static/media/flux_logo_light.5e44c4cd.svg","height":128,"width":461,"blurWidth":0,"blurHeight":0};